const LicenseType = [
  {
    Value: 1,
    Label: "Pre y Post Natal (98 días) (Ley 16-92 Art. 236)",
    Days: 98
  },
  {
    Value: 2,
    Label: "Paternidad (2 días) (Ley 16-92 Art. 54)",
    Days: 2
  },
  {
    Value: 3,
    Label: "Lactancia (1 Hora diaria durante un año) (Ley 16-92 Art. 240)",
    Hours: 1
  },
  {
    Value: 4,
    Label:
      "Consulta Niño recien nacido (Medio día cada mes) (Ley 16-92 Art. 243)",
    Hours: 4
  },
  {
    Value: 5,
    Label: "Celebración de Matrimonio (5 días) (Ley 16-92 Art. 54)",
    Days: 5
  },
  {
    Value: 6,
    Label: "Muerte Padres, Abuelos Hijos (3 días) (Ley 16-92 Art. 54)",
    Days: 3
  },
  {
    Value: 8,
    Label: "Otras (Licencia Por Enfermedad Común) (Ley 87-01 Art. 131)",
    Days: 0
  }
  // {
  //   Value: 9,
  //   Label: "Licencias por Estudios",
  //   Days: 0
  // }
];
export default LicenseType;
